import React, { useEffect, useState } from 'react';
import { Box, Drawer, Grid, IconButton, Card, Typography } from "@mui/material"
import { useDispatch } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import { getWasteProductDetails } from "../../../redux/slices/hyperwolf/inventoryDistribution";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";
import { formatTimestampToWithoutTime } from "utilities/common";
import { Link } from "react-router-dom";

export default function WasteInventorySKU({ open, TransitionComponent, handleClose }) {
  const dispatch = useDispatch()

  const [details, setDetails] = useState({});

  const handleProductDetails = async () => {
    try {
      const response = await dispatch(getWasteProductDetails(open.id)).unwrap()
      if (response?.data) {
        setDetails(response?.data || {})
      }
    } catch (error) {
      showToastMsg(error)
    }
  }

  useEffect(() => {
    if (open) {
      handleProductDetails()
    }
  }, [open]);

  console.log("details", details)

  return (
    <Drawer
      open={open}
      TransitionComponent={TransitionComponent}
      keepMounted
      maxWidth='xs'
      fullWidth
      className="cus-drawer discrepancy-stock-drawer"
      onClose={handleClose}
      anchor='right'
    >
      <Box p={1.25} className='d-flex align-item-center jc-s-btwn mb-3'>
        <Typography variant='h4' fontWeight='700' color="#2E2E3A" style={{ wordBreak: "break-word" }}>SKU-1234</Typography>
        <IconButton onClick={handleClose} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </Box>

      <Box p={{ xs: 1.25 }}>
        <Grid container spacing={3}>

          {/* Product Details */}
          <Grid item xs={12} md={12}>
            <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={2}>Product Details33</Typography>
            <ul className="w-100 d-grid mt-2" style={{ gap: "12px", paddingBottom: "12px" }}>
              <li className="w-100 d-flex gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" style={{ minWidth: "183px" }}>Product Name</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.productDetails?.productName}</Typography>
              </li>
            </ul>
            <ul className="w-100 d-grid grid-columns-two pb-2" style={{ gap: "12px" }}>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Brand</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.productDetails?.brand?.name}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Sub Category</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.productDetails?.category?.name}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Weight</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.productDetails?.weight}g</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Batch</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>
                  {details?.productDetails?.batches?.map((batch, idx) => (
                    <span key={batch?.batchNo + idx}>
                      {batch?.sku} (Qty {batch?.qty}){idx < details?.productDetails?.batches?.length - 1 ? ',' : null} <br />
                    </span>
                  ))}
                </Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">From Box</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.productDetails?.box?.name}</Typography>
              </li>
              {/* <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Retail Value</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>
                  ${details?.productDetails?.retailValue?.toLocaleString()}
                </Typography>
              </li> */}
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Kit Value</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>
                  ${details?.productDetails?.wholesaleValue?.toLocaleString()}
                </Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Value</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>${details?.productDetails?.amount?.toLocaleString()}</Typography>
              </li>
            </ul>
          </Grid>

          <Grid item xs={12}>
            <hr className='my-1' style={{ borderTop: "1px solid #D0D0DA", borderBottom: "none", borderLeft: "none", borderRight: "none" }} />
          </Grid>

          {/* Basic Information */}
          <Grid item xs={12} md={12}>
            <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={2}>Basic Information</Typography>
            <ul className="w-100 d-grid grid-columns-two pb-2" style={{ gap: "12px" }}>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Driver</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.basicInfo?.driver}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Reported By</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.basicInfo?.reportedby}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Distribution ID</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.basicInfo?.distributionId}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Discrepancy</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>
                  <Link to={`/hyperwolf/discrepancy-management?discrepancy=${details?.basicInfo?.discrepancyId}`} style={{ fontWeight: "700", display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                      <g clipPath="url(#clip0_17646_26061)">
                        <path d="M8.66665 12.5H1.99999C1.46573 12.5 0.963502 12.2919 0.585767 11.9142C0.208033 11.5364 0 11.0342 0 10.5V3.83333C0 3.2991 0.208057 2.79687 0.585791 2.41913C0.963525 2.0414 1.46576 1.83334 2.00001 1.83334H4.66667C5.03488 1.83334 5.33334 2.1318 5.33334 2.50001C5.33334 2.86822 5.03488 3.16668 4.66667 3.16668H1.99999C1.8219 3.16668 1.65451 3.23603 1.52861 3.36193C1.40272 3.48783 1.33334 3.65524 1.33334 3.83333V10.5C1.33334 10.6781 1.40269 10.8455 1.52861 10.9714C1.65451 11.0973 1.8219 11.1667 1.99999 11.1667H8.66662C8.84471 11.1667 9.0121 11.0973 9.13802 10.9714C9.26392 10.8455 9.33327 10.6781 9.33327 10.5V7.83333C9.33327 7.46512 9.63175 7.16668 9.99996 7.16668C10.3682 7.16668 10.6667 7.46514 10.6667 7.83333V10.5C10.6667 11.0342 10.4586 11.5364 10.0808 11.9142C9.70309 12.2919 9.20083 12.5 8.66665 12.5ZM4.66667 8.49998C4.49604 8.49998 4.32543 8.43491 4.19527 8.30473C3.93493 8.04439 3.93493 7.62225 4.19527 7.36191L9.72381 1.83334H7.33333C6.96512 1.83334 6.66668 1.53488 6.66668 1.16667C6.66668 0.798461 6.96512 0.5 7.33333 0.5H11.3333C11.4255 0.5 11.5133 0.518724 11.5932 0.552561C11.6678 0.584094 11.7378 0.629785 11.799 0.689659L11.7991 0.689705C11.7995 0.690148 11.8 0.690567 11.8004 0.69101C11.8005 0.691126 11.8007 0.691266 11.8008 0.691382C11.8011 0.691708 11.8015 0.692058 11.8018 0.692407C11.802 0.69264 11.8022 0.692849 11.8025 0.693082C11.8027 0.693338 11.803 0.693618 11.8032 0.693827C11.8037 0.694293 11.8042 0.694782 11.8047 0.695271C11.8051 0.695737 11.8056 0.696249 11.8061 0.696715C11.8064 0.696948 11.8066 0.697251 11.8068 0.69746C11.8071 0.697693 11.8073 0.697903 11.8075 0.698136C11.8079 0.698485 11.8082 0.698811 11.8085 0.699184C11.8086 0.699277 11.8088 0.69944 11.8089 0.699556C11.8093 0.699999 11.8098 0.700441 11.8102 0.700884L11.8102 0.70093C11.8701 0.762225 11.9158 0.832229 11.9473 0.906751C11.9812 0.98663 11.9999 1.07443 11.9999 1.16665V5.16665C11.9999 5.53486 11.7014 5.83332 11.3332 5.83332C10.965 5.83332 10.6666 5.53486 10.6666 5.16665V2.77616L5.13795 8.30475C5.00789 8.43493 4.83728 8.49998 4.66667 8.49998Z" fill="#2E2E3A" />
                      </g>
                      <defs>
                        <clipPath id="clip0_17646_26061">
                          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                    <u>Link</u>
                  </Link>
                </Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Discrepancy Date</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{formatTimestampToWithoutTime(details?.basicInfo?.createdDate)}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Discrepancy Type</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.basicInfo?.discrepancyType}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Sub Region</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.basicInfo?.subRegion?.name}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Region</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>{details?.basicInfo?.region?.region}</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Qty Waste</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>
                  {details?.basicInfo?.wasteQuantity?.map((batch, idx) => (
                    <span key={batch?.batchNo + idx} style={{ wordBreak: "break-word" }}>
                      {batch?.batchNo} (Qty {batch?.qty}){idx < details?.basicInfo?.wasteQuantity?.length - 1 ? ',' : null} <br />
                    </span>
                  ))}
                </Typography>
              </li>
              {/* <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Resolve By</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>June 22, 2025 | 11:30AM</Typography>
              </li> */}
            </ul>
          </Grid>

          <Grid item xs={12}>
            <hr className='my-1' style={{ borderTop: "1px solid #D0D0DA", borderBottom: "none", borderLeft: "none", borderRight: "none" }} />
          </Grid>

          {/* <Grid item xs={12} md={12}>
            <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={2}>Approval and Audit Trail</Typography>
            <ul className="w-100 d-grid grid-columns-two pb-2" style={{ gap: "12px" }}>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Verified By</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>Alex (Inventory Manager)</Typography>
              </li>
              <li className="w-100 d-flex align-item-center gap-1">
                <Typography variant='body2' fontWeight="normal" color="#656575" className="flex-1">Date Marked</Typography>
                <Typography variant='body2' fontWeight="500" color="#2E2E3A" className="flex-1" style={{ wordBreak: "break-word" }}>June 25, 2025</Typography>
              </li>
            </ul>
          </Grid> */}

          <Grid item xs={12}>
            <hr className='my-1' style={{ borderTop: "1px solid #D0D0DA", borderBottom: "none", borderLeft: "none", borderRight: "none" }} />
          </Grid>

          {/* Notes */}
          {(details?.note || details?.photos?.length > 0) && <Grid item xs={12} md={12}>
            <Card sx={{ p: 2, borderRadius: 2.5, boxShadow: 'none', background: '#F2F3F7' }}>
              <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={1}>Notes</Typography>
              <Typography variant='body2' fontWeight="normal" color="#656575" style={{ wordBreak: "break-word" }}>{details?.note}</Typography>
              <Box display="flex" alignItems="start" flexWrap="wrap" gap={1} style={{ padding: "12px 0 16px" }}>
                {
                  details?.photos?.map(photo => {
                    <Box key={photo} style={{ width: "80px", height: "80px", borderRadius: "12px", background: "#F1F1F1", overflow: "hidden" }}>
                      <img src={photo} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </Box>
                  })
                }
              </Box>
              {/* <Box display="flex" alignItems="center" gap={1}>
                <Typography variant='body2' fontWeight="600" lineHeight="normal" color="#2E2E3A">Sarah Chen</Typography>
                <span style={{ lineHeight: "normal" }}>|</span>
                <Typography variant='body2' fontWeight="500" lineHeight="normal" color="#2E2E3A">June 24, 2025</Typography>
              </Box> */}
            </Card>
          </Grid>}

          {/* Driver Comments */}
          {(details?.driverComments?.comment || details?.driverComments?.photos?.length > 0) && <Grid item xs={12} md={12}>
            <Card sx={{ p: 2, borderRadius: 2.5, boxShadow: 'none', background: '#F2F3F7' }}>
              <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={1}>Driver Comments</Typography>
              <Typography variant='body2' fontWeight="normal" color="#656575" style={{ wordBreak: "break-word" }}>{details?.driverComments?.comment}</Typography>
              <Box display="flex" alignItems="start" flexWrap="wrap" gap={1} style={{ padding: "12px 0 16px" }}>
                {
                  details?.driverComments?.photos?.map(photo => {
                    <Box key={photo} style={{ width: "80px", height: "80px", borderRadius: "12px", background: "#F1F1F1", overflow: "hidden" }}>
                      <img src={photo} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </Box>
                  })
                }
              </Box>
              {/* <Box display="flex" alignItems="center" gap={1}>
                <Typography variant='body2' fontWeight="600" lineHeight="normal" color="#2E2E3A">Sarah Chen</Typography>
                <span style={{ lineHeight: "normal" }}>|</span>
                <Typography variant='body2' fontWeight="500" lineHeight="normal" color="#2E2E3A">June 24, 2025</Typography>
              </Box> */}
            </Card>
          </Grid>}

          {/* Discrepancy Approvals Notes */}
          {(details?.discrepancyApproval?.additionalNote || details?.discrepancyApproval?.additionalPhotos?.length > 0) && <Grid item xs={12} md={12}>
            <Card sx={{ p: 2, borderRadius: 2.5, boxShadow: 'none', background: '#F2F3F7' }}>
              <Typography variant='h6' fontWeight="700" color="#2E2E3A" mb={1}>Discrepancy Approvals Notes</Typography>
              <Typography variant='body2' fontWeight="normal" color="#656575" style={{ wordBreak: "break-word" }}>{details?.discrepancyApproval?.additionalNote}</Typography>
              <Box display="flex" alignItems="start" flexWrap="wrap" gap={1} style={{ padding: "12px 0 16px" }}>
                {
                  details?.discrepancyApproval?.additionalPhotos?.map(photo => {
                    <Box key={photo} style={{ width: "80px", height: "80px", borderRadius: "12px", background: "#F1F1F1", overflow: "hidden" }}>
                      <img src={photo} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </Box>
                  })
                }
              </Box>
              {/* <Box display="flex" alignItems="center" gap={1}>
                <Typography variant='body2' fontWeight="600" lineHeight="normal" color="#2E2E3A">Sarah Chen</Typography>
                <span style={{ lineHeight: "normal" }}>|</span>
                <Typography variant='body2' fontWeight="500" lineHeight="normal" color="#2E2E3A">June 24, 2025</Typography>
              </Box> */}
            </Card>
          </Grid>}

        </Grid>
      </Box>

    </Drawer>
  )
}
